import { useMemo } from 'react'
import { useCommonCodes } from '../context/CommonCodesContext'

/**
 * 스케줄 전용 행정 공정(세대 동의서 청구·공사신고서 제출·엘리베이터 사용 신청 등, 공종 마스터 scheduleOnlyYn='Y')의 공종코드.
 * 시공·자재가 없어 간트·캘린더·리스트 모두 신호등을 그리지 않고 공종 상세(시공파트너·자재거래처)를 열지 않는다.
 */
export function useScheduleOnlyCodes(): Set<string> {
  const { codes } = useCommonCodes()
  return useMemo(
    () => new Set((codes?.workTypes ?? []).filter(w => w.scheduleOnlyYn === 'Y').map(w => w.workTypeCode)),
    [codes?.workTypes],
  )
}
